import GrpTabLayout from "../_GrpTabLayout";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";
import usePageTitle from "@/hooks/usePageTitle";

export default function MemberContributions() {
  usePageTitle("/billing/finance/grp/member-contributions", "Contributions");
  useRequireCapability({ domain: DOMAIN.BENEFIT_PROGRAMS, permission: PERMISSION.viewMemberContributions });

  return <GrpTabLayout />;
}
